<!-- <div id="app" class="h-100 app" [ngClass]="settings.theme">  -->
    <!-- <router-outlet></router-outlet>  -->
    
    <!-- commented by jibin-->
     <!-- commented by jibin-->
    <!-- <ngx-spinner [bdOpacity]= "0.7" [bdColor] = "'#333'" [size] = "'large'" [color] = "'#fff'" [type] = "'ball-clip-rotate'"></ngx-spinner>      -->
    <!-- <ngx-spinner bdColor="rgba(51,51,51,0.7)" size="large" color= "#fff" type="ball-clip-rotate"></ngx-spinner>   -->
       
<!-- </div> -->

<!-- <div style="position: relative;top: 100%;margin-top: auto;"><app-footer></app-footer></div> -->

<!-- changed code -->
<div id="app" class="h-100 app" [ngClass]="settings.theme" style="display: flex; flex-direction: column; min-height: 100vh;">
    <router-outlet></router-outlet>
    <div style="margin-top: auto;">
      <span *ngIf="appService.islogin"><app-footer></app-footer></span>
    </div>
</div>  
<!-- end code -->

